// extracted by mini-css-extract-plugin
module.exports = {"background":"styles-about-module--background--2GCbv","customMedia":{},"customProperties":{},"customSelectors":{}};